'use client'

import { ReactNode } from 'react'
import { cn } from '~/utils/cn'
import {
  ArchiveIcon,
  CopyLinkIcon,
  DeleteIcon,
  DownloadIcon,
  DuplicateIcon,
  NewVersionIcon,
  SelectedIcon,
  VersionsIcon,
} from './Icons'
import { InlineTooltip } from '~/components/Tooltip'
import {
  MultiLevelMenu,
  MultiLevelMenuItem,
} from '~/components/MultiLevelMenu/MultiLevelMenu'

const defaultMenuItems: MultiLevelMenuItem[] = [
  {
    name: 'copy',
    label: 'Copy link',
    onClick() {
      console.log('copy')
    },
    IconLeft: CopyLinkIcon,
  },
  {
    name: 'duplicate',
    label: 'Duplicate',
    onClick() {
      console.log('Duplicate')
    },
    IconLeft: DuplicateIcon,
  },
  {
    name: 'download',
    label: 'Download',
    onClick() {
      console.log('Download')
    },
    IconLeft: DownloadIcon,
  },
  {
    name: 'archive',
    label: 'Archive',
    onClick() {
      console.log('Archive')
    },
    IconLeft: ArchiveIcon,
  },
  {
    name: 'delete',
    label: 'Delete',
    onClick() {
      console.log('Archive')
    },
    IconLeft: DeleteIcon,
  },
  {
    name: 'versions',
    label: 'Versions',
    onClick() {
      console.log('Duplicate')
    },
    IconLeft: VersionsIcon,
    subMenu: [
      {
        name: 'version4',
        label: 'Version 4',
        onClick() {
          console.log('Version 4 Clicked')
        },
        IconRight: SelectedIcon,
        buttonClassName: 'text-primary-500',
      },
      {
        name: 'version3',
        label: 'Version 3',
        onClick() {
          console.log('Version 3 Clicked')
        },
        buttonClassName: 'text-[#A9A9A9]',
      },
      {
        name: 'version2',
        label: 'Version 2',
        onClick() {
          console.log('Version 2 Clicked')
        },
        buttonClassName: 'text-[#A9A9A9]',
      },
      {
        name: 'version1',
        label: 'Version 1',
        onClick() {
          console.log('Version 1 Clicked')
        },
        buttonClassName: 'text-[#A9A9A9]',
      },
      {
        name: 'newversion',
        label: 'New Version',
        onClick() {
          console.log('New Version Clicked')
        },
        IconRight: NewVersionIcon,
        containerClassName: 'border-t border-gray-100',
      },
    ],
  },
]

type EvaluationMenuProps = {
  children: ReactNode
  menuItems?: MultiLevelMenuItem[]
  buttonClassName?: string
  renderButtonContentClassName?: (open: boolean) => string
  menuContainerClassName?: string
  tooltipText?: string
}

export const EvaluationMenu = ({
  menuItems = defaultMenuItems,
  children,
  tooltipText,
  buttonClassName,
  renderButtonContentClassName,
  menuContainerClassName,
}: EvaluationMenuProps) => {
  return (
    <MultiLevelMenu
      menuContainerClassName={cn('right-0 mt-2', menuContainerClassName)}
      menuItems={menuItems}
      renderButtonContent={(open) => (
        <InlineTooltip tooltip={tooltipText}>
          <div
            className={cn(
              open ? 'text-primary-500' : 'text-gray-500',
              renderButtonContentClassName?.(open)
            )}
          >
            {children}
          </div>
        </InlineTooltip>
      )}
      buttonClassName={buttonClassName}
    />
  )
}
